import { navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
                91
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-base font-bold text-background-50">91免费版</span>
                <span className="text-[11px] text-background-300">下载安装指引中心</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-background-300">
              本页整理 91免费版app下载安装指引，覆盖安卓与 iOS 平台，包含安装包获取、安装步骤与使用说明，
              帮助需要下载91免费版app的用户解决找不到安装包或安装失败的常见问题。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['官方通道', '签名校验', '双端适配'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-[11px] text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-xs text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">支持</h3>
            <ul className="mt-4 space-y-2.5 text-xs text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-300" />
                安装包签名校验说明
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-file-list-3-line text-accent-300" />
                常见报错对照表
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-history-line text-accent-300" />
                历史版本记录
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-lock-2-line text-accent-300" />
                隐私与权限说明
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 border-t border-background-50/15 pt-6 text-[11px] text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91免费版 下载安装指引中心 · 页面内容仅供安装参考</p>
          <p>本站不存储任何安装包文件，安装前请核对来源与签名信息</p>
        </div>
      </div>
    </footer>
  );
}